const u = navigator.userAgent.toLowerCase()
const p = navigator.platform.toLowerCase()
const d = /firefox/.test(u) // isFirefox
const r = /opera|opr\/[\d]+/.test(u) // isOpera
const k = !r && /(msie|trident)/.test(u) // isIE
const e = /edge\/(\d+)/.test(u) // isEdge
const b = !r && !e && /chrome/.test(u) && /webkit/.test(u) // isChrome
const o = !r && !e && !b && /safari/.test(u) // isSafari

const userAgents = navigator.userAgent.split(' ')
const language = userAgents[userAgents.indexOf('language')] || ''

export default {
  // 移动终端浏览器版本信息
  win: p ? /win/.test(p) : /win/.test(u),
  mac: p ? /mac/.test(p) : /mac/.test(u),
  trident: u.indexOf('trident') > -1, // IE内核
  opera: r, // opera
  webKit: u.indexOf('applewebkit') > -1, // 苹果、谷歌内核
  firefox: d, // 火狐
  ie: k,
  ieVersion: '',
  safari: o,
  edge: e,
  chrome: b,
  mobile: !!u.match(/applewebkit.*mobile.*/), // 是否为移动终端
  ios: !!u.match(/\(i[^;]+;?( u;)? cpu.+mac os x/), // ios终端
  android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, // android终端或者uc浏览器
  iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, // 是否为iPhone
  iPad: u.indexOf('ipad') > -1, // 是否iPad
  webApp: u.indexOf('safari') === -1, // 是否web应该程序，没有头部与底部
  weixin: !!u.match(/micromessenger/i),
  wxwork: !!u.match(/wxwork/i),
  winwechat: u.toLowerCase().includes('windowswechat'), // u.indexOf('windowswechat') > 0, // windows 微信客户端
  dingtalk: u.includes('dingtalk') || u.toLowerCase().includes('dingtalk'), // u.indexOf('dingtalk') > 0, // 钉钉
  qqbrowser:
    !u.match(/micromessenger/i) &&
    u.includes('mqqbrowser') && // u.indexOf('mqqbrowser') > 0
    u.indexOf('yxtapp') < 0, // 手机qq浏览器
  ios9: u.match(/os [9]_\d[_\d]* like mac os x/i),
  qq: u.indexOf('qq/') > -1, // qq壳
  fxiaoke: u.indexOf('fsbrowser') > -1,
  lanxin: u.toLowerCase().indexOf('lanxin') > -1, // 蓝信
  language: (language.split('/')[1] || navigator.language).toLowerCase(),
  isFeishu: u.indexOf('lark') > -1,
  get isPCFeishu() {
    return this.isFeishu && !this.mobile
  },
  wxmp: window.__wxjs_environment === 'miniprogram' // 微信小程序
}
